import type { Edge, Node } from '@xyflow/react';
import type { Workflow } from './types';
import { NODE_ORDER } from './types';

const ROW_HEIGHT = 280;
const ROW_TOP_PAD = 60;
const COL_X: Record<string, number> = {
  source:    40,
  spike:    320,
  finalized: 560,
  edit:     800,
  gate:    1140,
  output:  1440
};

export function buildGraph(workflows: Workflow[]): { nodes: Node[]; edges: Edge[] } {
  const nodes: Node[] = [];
  const edges: Edge[] = [];

  workflows.forEach((wf, row) => {
    const y = ROW_TOP_PAD + row * ROW_HEIGHT;
    for (const key of NODE_ORDER) {
      nodes.push({
        id: `${wf.id}:${key}`,
        type: key,
        position: { x: COL_X[key], y },
        data: { workflowId: wf.id },
        draggable: false,
        selectable: false,
        deletable: false
      });
    }
    for (let i = 0; i < NODE_ORDER.length - 1; i++) {
      const from = NODE_ORDER[i];
      const to = NODE_ORDER[i + 1];
      const live =
        wf.states[from].kind !== 'idle' && wf.states[from].kind !== 'done'
          ? 'live'
          : '';
      edges.push({
        id: `${wf.id}:${from}->${to}`,
        source: `${wf.id}:${from}`,
        target: `${wf.id}:${to}`,
        type: 'smoothstep',
        animated: live === 'live',
        className: live,
        deletable: false,
        selectable: false
      });
    }
  });

  return { nodes, edges };
}
